import Vue from 'vue'
import Vuex from 'vuex'
import { getToken, setToken } from '@/utils/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: getToken()
  },
  getters: {
    isLogin: (s) => !!s.token
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token || ''
      setToken(state.token)
    }
  }
})
